import { connect } from 'react-redux'

import { changeLoginState } from '../actions/login'
import LoginNew from '../components/login-new'

const mapStateToProps = (state) => ({
    requestLoginLinkAPIURL: state.initial.endpoints.requestLoginLinkAPIURL,
    staticRoot: state.initial.staticRoot,
})

const matchDispatchToProps = (dispatch) => ({
    changeLoginState: (loginState) => {
        return dispatch(changeLoginState(loginState))
    },
})

export default connect(mapStateToProps, matchDispatchToProps)(LoginNew)
